import { useEffect, useState } from 'react'
import { LoginActions, QueryParameterNames, ApplicationPaths } from './ApiAuthorizationConstants';
import LoadingIcon from '../LoadingIcon';

// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.
export function Login(props: { action: string }) {
  const [ message, setMessage ] = useState<string | null>(null);
  const action = props.action;

  const processLoginCallback = async() => {
    const url = window.location.href;
    await navigateToReturnUrl(getReturnUrl({ returnUrl: url }));
  }

  const getReturnUrl = (state?: { returnUrl: string }) => {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get(QueryParameterNames.ReturnUrl);
    
    return (state && state.returnUrl) || fromQuery || `${window.location.origin}/`;
  }

  const redirectToLogin = (returnUrl: string) => {
    redirectToApiAuthorizationPath(`${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`);
  }

  const redirectToRegister = () => {
    redirectToApiAuthorizationPath(`${ApplicationPaths.IdentityRegisterPath}?${QueryParameterNames.ReturnUrl}=${encodeURI(ApplicationPaths.Login)}`);
  }

  const redirectToProfile = () => {
    redirectToApiAuthorizationPath(ApplicationPaths.IdentityManagePath);
  }

  const redirectToApiAuthorizationPath = (apiAuthorizationPath: string) => {
    const normalizedPath = `/${apiAuthorizationPath}`.replace('//', '/');
    const redirectUrl = `${window.location.origin}${normalizedPath}`;
    // It's important that we do a replace here so that when the user hits the back arrow on the
    // browser they get sent back to where it was on the app instead of to an endpoint on this
    // component.
    window.location.replace(redirectUrl);
  }

  const navigateToReturnUrl = (returnUrl: string) => {
    // It's important that we do a replace here so that we remove the callback uri with the
    // fragment containing the tokens from the browser history.
    window.location.replace(returnUrl);
  }

  useEffect(() => {
    switch (action) {
      case LoginActions.Login:
        redirectToLogin(getReturnUrl());
        break;
      case LoginActions.LoginCallback:
        processLoginCallback();
        break;
      case LoginActions.LoginFailed:
        const params = new URLSearchParams(window.location.search);
        const error = params.get(QueryParameterNames.Message);
        setMessage(error);
        break;
      case LoginActions.Profile:
        redirectToProfile();
        break;
      case LoginActions.Register:
        redirectToRegister();
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }, []);

  if (!!message) {
    return <div>{message}</div>
  } else {
    switch (action) {
      case LoginActions.Login:
        return ( <LoadingIcon />);
      case LoginActions.LoginCallback:
        return (<div>Processing login callback</div>);
      case LoginActions.Profile:
      case LoginActions.Register:
        return (<div></div>);
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }
}
